import { useCallback, useState } from 'react';
import { StyleSheet, View } from 'react-native';
import { AudioPlayer } from '../AudioPlayer';
import { HearingChoices } from '../HearingChoices';
import { TextBody } from '../SpeakingExercise/textBody';

// styles
import _STYLES from './styles';

const styles = StyleSheet.create({
  container: {
    width: '100%',
    alignItems: 'center',
    padding: 10,
  },
  playerContainer: {
    flex: 1,
    width: '100%',
    justifyContent: 'center',
    alignItems: 'center',
  },
  miniPlayerContainer: {
    flex: 2,
    width: '100%',
    justifyContent: 'center',
    alignItems: 'center',
  },
});

export function Body({
  id,
  questions,
  questionIndex,
  settings,
  choices,
  onPressChoice,
  playbackRate = 1.0,
}) {
  const { questionAudio } = questions?.[questionIndex] ?? {};
  const [activeAudioSrc, setActiveAudioSrc] = useState('');

  const changeActiveAudioSrc = useCallback((src) => {
    setActiveAudioSrc(src);
  }, []);

  return (
    <View style={[_STYLES.container, styles.container]}>
      {settings === 'open' ? (
        <TextBody
          id={id}
          questions={questions}
          questionIndex={questionIndex}
          playbackRate={playbackRate}
        />
      ) : (
        <>
          <View style={styles.playerContainer}>
            <AudioPlayer
              isStopAllOnPlay
              changeActiveAudioSrc={changeActiveAudioSrc}
              playingAudioSrc={activeAudioSrc}
              source={questionAudio}
              autoPlay
              playbackRate={playbackRate}
            />
          </View>
          <View style={styles.miniPlayerContainer}>
            <HearingChoices
              changeActiveAudioSrc={changeActiveAudioSrc}
              activeAudioSrc={activeAudioSrc}
              choices={choices}
              onPressChoice={onPressChoice}
              playbackRate={playbackRate}
            />
          </View>
        </>
      )}
    </View>
  );
}
